<template>
  <section class="change">
    <p class="title">港股异动</p>
    <p class="more"><a :href="$i18n.path('news?type=hkstockchange')" target="_blank">查看更多</a><span class="arrow">></span>
    <div style="background-color:#F1F3F7;width:100%;height:1px;"></div>
    <section class="content">
      <div class="content_row" v-for="item in hkChange" :key="item.id">
        <div class="text">
          <a class="nuxtLink" :href="`/news/${item.id}`" target="_blank">{{item.title}}</a>
        </div>
        <div class="date">
          {{ format_date(item.createDate)}}
        </div>
      </div>
    </section>
</div>
  </section>
</template>

<script>
export default {
  props:['hkChange'],
  methods:{
    format_date(timeStamp){
      var time = new Date(timeStamp*1000);
      var y = time.getFullYear();
      var m = time.getMonth()+1;
      var d = time.getDate();
      return y+"-"+m+"-"+d
    }
  }

}
</script>

<style lang="less" scoped>
.change {
  // width:100%;
  .title {
    display: inline-block;
    padding-bottom: 12px;
    border-bottom: 3px solid #3278D2;

    font-size:18px;
    font-weight:bold;
    color:rgba(34,34,34,1);
  }
}
.more {
  float: right;
  margin-top: 5px;
  a{
    font-size:12px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color:rgba(131,141,151,1);
  }
  .arrow {
    color:rgba(141,150,159,1);
    border-radius: 1px;
    margin-left: 3px;
  }
}
.more:hover{
  cursor: pointer;
}
.text {
  display: inline-block;
  width:70%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size:14px;
  font-family:MicrosoftYaHei;
  font-weight:400;
  color:rgba(34,34,34,1);
}
.nuxtLink{
  color:#222222;
}
.nuxtLink:hover{
  color: #3278D2;
  cursor: pointer;
}
.content{
  margin-top:10px;
}
.content_row {
  padding: 10px 0;
}
.date {
  font-size:12px;
  font-family:MicrosoftYaHei;
  font-weight:400;
  color:rgba(153,153,153,1);

  display:inline-block;
  float:right;
}
</style>

